import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControlPipe } from "@bequeathed/ngx-utils";
import { BaseInputControl } from '../base-input-control/base-input-control.component';
import { NgClass } from "@angular/common";
import { ReactiveFormsModule, Validators } from "@angular/forms";

/**
 * Control to retrieve content as a percentage, typically refers to an integer but displays a '%' sign
 * as a suffix
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    selector: 'percentage-control',
    templateUrl: './percentage-control.component.html',
    styleUrls: [
        './percentage-control.component.sass',
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    standalone: true,
    imports: [
        // Angular
        NgClass,
        ReactiveFormsModule,
        // Bequeathed
        FormControlPipe,
    ],
    encapsulation: ViewEncapsulation.None
})
export class PercentageControl extends BaseInputControl implements OnInit {

    constructor() {
        super();
        this.inputType = 'number';
    }

    override ngOnInit(): void {
        this.determineValidators();
        this.validators.push(Validators.pattern(/^[0-9]+$/));
        super.ngOnInit();

        if (this.editingResponse) {
            this.setPreviousResponse()
        }
    }
}
